import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import jwt_decode from 'jwt-decode';
import {
    getErrorMessage,
    getUserData,
    isAuthenticated,
    setAccessToken,
    subscribe,
    unsubscribe
} from '../../services/AuthServices';
import {getTokenFromTicket} from '../../services/api/apiAuthentication';
import {extendUrlIPCC} from '../../store/getUrlLogin';
import {getRoleByUserName} from '../../services/api/apiUser';
import parseToken from '../../helpers/parseToken';
import {setLocalData} from '../../services/StorageServices';
import {fetchListRoles} from '../../store/action';

class WithAuthentication extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: isAuthenticated(),
            user: this._getUserObject(),
            error: getErrorMessage(),
            roles: this.props.roles,
            isLoading: false
        };

        this._handleTicketFromUrl();
    }

    componentDidMount() {
        subscribe(this._handleAuthChange);
    }

    componentWillUnmount() {
        unsubscribe(this._handleAuthChange);
    }

    _handleTicketFromUrl = () => {
        const {history} = this.props;
        if (!history?.location?.search) return;

        const params = new URLSearchParams(history.location.search);
        const ticket = params.get('ticket');

        if (ticket) {
            setAccessToken(`ticket${ticket}`, `ticket${ticket}`);
            this._getAccessToken(ticket);
        }
    };

    _getRoleFromUserName = async (user) => {
        try {
            const response = await getRoleByUserName({userName: user});
            const {data, success, error_message} = response;

            if (parseInt(success) !== 1) {
                console.error('Get roles error:', error_message);
                return;
            }

            await setLocalData('roles', data);
            this.props.getRoles(data);

            this.setState({roles: data});
        } catch (e) {
            console.error('Get roles exception:', e.message);
        }
    };

    _getAccessToken = async (ticket) => {
        this.setState({isLoading: true});

        try {
            const payload = {
                ticket,
                appCode: 'ipcc',
                serviceUrl: extendUrlIPCC.url
            };

            const response = await getTokenFromTicket(payload);

            if (response?.token) {
                const decodedToken = jwt_decode(response.token);
                await setAccessToken(response.token, decodedToken.apiKey);

                const decodeToken = parseToken();
                await setLocalData('apiKey', decodeToken.apiKey);
                await this._getRoleFromUserName(decodeToken.sub);
            }
        } catch (e) {
            console.error('Get access token error:', e.message);
            this.setState({error: e.message});
        } finally {
            this.setState({isLoading: false});
        }
    };

    _hasRole = (role = '') => {
        const {user} = this.state;
        const roles = Array.isArray(user.roles) ? user.roles : [];
        return roles.includes(role);
    };

    _getProfile = (key = '') => {
        const {user} = this.state;
        const profile = {...user.profile};

        return key ? (profile[key] || null) : profile;
    };

    _getUserObject = () => {
        const user = getUserData();

        return {
            ...user,
            hasRole: this._hasRole,
            getProfile: this._getProfile,
        };
    };

    _handleAuthChange = () => {
        this.setState({
            isAuthenticated: isAuthenticated(),
            user: this._getUserObject(),
            error: getErrorMessage(),
            roles: this.props.roles
        });
    };

    render() {
        return this.props.children(this.state);
    }
}

WithAuthentication.propTypes = {
    children: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    roles: state.rolesReducer.roles,
});

const mapDispatchToProps = (dispatch) => ({
    getRoles: (roles) => dispatch(fetchListRoles(roles)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithAuthentication);